import { render, staticRenderFns } from "./NoLayout.vue?vue&type=template&id=2b81373f&scoped=true&"
import script from "./NoLayout.vue?vue&type=script&lang=js&"
export * from "./NoLayout.vue?vue&type=script&lang=js&"
import style0 from "./NoLayout.vue?vue&type=style&index=0&id=2b81373f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b81373f",
  null
  
)

export default component.exports